const THREE = require('three')
import {loadingManager, load} from '../loader'
import {TimelineMax, Cubic} from 'gsap'

export let mesh = new THREE.Object3D()
export default mesh


export let data = {
  // 8: {
  //   url: require('assets/race/masks/8.png'),
  //   size: 2211,
  //   played: false
  // },
  // 12: {
  //   url: require('assets/race/masks/12.png'),
  //   size: 2395,
  //   played: false
  // },
  // 21: {
  //   url: require('assets/race/masks/21.png'),
  //   size: 2425,
  //   played: false
  // }
  // 31: {
  //   url: require('assets/race/masks/31.png'),
  //   size: 2403,
  //   played: false
  // }
}


// LOAD
for (let id in data) {

  const distance = data[id]

  load(distance.url, new THREE.TextureLoader(loadingManager), (results)=> {

    let material = new THREE.SpriteMaterial({
      map: results[0],
      color: 0xff0000,
      transparent: true,
      alphaTest: 0.5,
      // blending: THREE.AdditiveBlending,
      opacity: 1
    })

    let sprite = new THREE.Sprite( material )

    distance.sprite = sprite
    mesh.add(sprite)
  })
}



// PLAY
export const play = (id)=> {

  if (data[id] === undefined) return

  if (data[id].played) return
  data[id].played = true

  let tl = new TimelineMax()

  let sprite = data[id].sprite
  sprite.scale.setScalar(Math.max(window.innerWidth, window.innerHeight))

  let mat = sprite.material
  tl.to(mat, 0, {opacity: 1, ease: Cubic.easeInOut, onUpdate: ()=>{ mat.needsUpdate = true }})
  tl.to(mat, 0, {opacity: 0, ease: Cubic.easeInOut, onUpdate: ()=>{ mat.needsUpdate = true }, delay: 1})

  tl.play()
}




// WEBPACK FOOTER //
// ./src/components/game/ui/distance.js